import React, { useState, useCallback, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';

import { format, parseISO } from 'date-fns';
import { isArray, groupBy, isEmpty } from 'lodash';
import qs from 'querystring';

import { Input } from '~/components/Form';
import { Report, Modal } from '~/components';
import { Shifts, TableMinimizable } from '~/componentslocal';
import { t, number } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';
import Form from './Form';

export default function DlgManutDadosDescarga() {
  const [open, setOpen] = useState(true);
  const [grid, setGrid] = useState(false);
  const [toolbar, setToolbar] = useState({});
  const [items, setItems] = useState([]);

  const formRef = useRef(null);
  const modalRef = useRef(null);

  const title = useMemo(() => 'Alterar Dados Descarga', []);

  const initial = useMemo(
    () => ({
      datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const headerMinimizable = useMemo(
    () => [
      { id: 'post_desc', label: 'Posto' },
      {
        id: 'desc_datahora',
        label: 'Data',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      { id: 'desc_num_pedido', label: 'Número Pedido', align: 'center' },
      { id: 'desc_num_doc', label: 'Número NF/RVT', align: 'center' },
      { id: 'desc_veic_doc', label: 'Número CT/VT', align: 'center' },
      {
        id: 'desc_dt_emissao_nf',
        label: 'Data Emissão NF',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      { id: 'desc_vol_20_total', label: 'Volume', align: 'right' },
    ],
    []
  );

  const handleOnClose = useCallback(() => setOpen(false), []);

  const handleCallbackToolbar = useCallback((data) => setToolbar(data), []);

  const handleCallbackMinimizable = useCallback(async (data) => {
    try {
      const response = await api.get(
        '/manutencaocontrole/getmanutencaoagendaexiste',
        {
          params: {
            chave: `(POST_COD_POSTO = &#183${data.post_cod_posto}&#183 AND ABAS_COD_ABAS = ${data.desc_cod_desc})`,
            status: 'P',
            codigoposto: data.post_cod_posto,
            codtarefa: 0,
          },
        }
      );

      if (isEmpty(response.data)) modalRef.current.handleOpenModal({ data });
      else toast.error('Atenção: Já existe uma tarefa agendada em aberto!');
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleGetDetailsAPI = useCallback(async (data) => {
    try {
      const response = await api.get('/descargas/descargamanutencao', {
        params: data,
        paramsSerializer: (s) => qs.stringify(s),
      });

      setItems(groupBy(response.data.items, 'post_desc'));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleBeforeSending = useCallback(
    (data) => {
      const { initial, final, tank } = toolbar;

      const wherefield = ['datahorainicial', 'datahorafinal'];
      const typewherefield = ['MAIOR_IGUAL', 'MENOR_IGUAL'];
      const valuewherefield = [initial, final];

      if (tank) {
        wherefield.push('post_cod_posto');
        typewherefield.push('EQUALS');
        valuewherefield.push(tank);
      }

      if (data.desc_num_doc) {
        wherefield.push('desc_num_doc');
        typewherefield.push('EQUALS');
        valuewherefield.push(data.desc_num_doc);
      }

      setGrid(true);
      handleGetDetailsAPI({
        wherefield,
        typewherefield,
        valuewherefield,
        pagesize: 99999,
      });

      // return undefined;
    },
    [toolbar]
  );

  if (!grid)
    return (
      <Report
        open={open}
        onClose={handleOnClose}
        title={title}
        relatorio=""
        serialize={handleBeforeSending}
        initials={initial}
      >
        <Shifts forms={formRef} onToolbar={handleCallbackToolbar} />

        <Input name="desc_num_doc" label="Nº CT/VT" />
      </Report>
    );

  return (
    <S.Wrapper>
      <S.Header>
        <li>
          <span>Data</span> {toolbar.issuance_date}
        </li>
        <li>
          <span>Posto</span> {toolbar.station}
        </li>
        <li>
          <span>Período</span> {toolbar.period}
        </li>
      </S.Header>

      <TableMinimizable
        header={headerMinimizable}
        data={items}
        onCallback={handleCallbackMinimizable}
        maxHeight={22}
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        title={title}
        ref={modalRef}
        component={Form}
        onForm={handleBeforeSending}
        maxWidth="sm"
      />
    </S.Wrapper>
  );
}
